import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { LandingLayoutComponent } from "@modules/landing/landing-layout.component";
import { ComponentsModule } from "@components/components.module";
import { LandingLayoutModule } from "@modules/landing/landing-layout.module";
import { NotificationFacade } from "@redux/facades/notification.facade";
import { LanguageFacade } from "@redux/facades/language.facade";
import { reducers } from "@redux/reducers";
import { LoaderFacade } from "@redux/facades/loader.facade";
import { AuthComponent } from "@modules/auth/auth.component";
import { PipesModule } from "@pipes/pipes.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { AdminLayoutComponent } from "@modules/admin/admin-layout.component";
import { MenuFacade } from "@redux/facades/menu.facade";
import {CalendarModule, DateAdapter} from "angular-calendar";
import {adapterFactory} from "angular-calendar/date-adapters/date-fns";

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    /** Layouts */
    AdminLayoutComponent,
    LandingLayoutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    LandingLayoutModule,
    StoreModule.forRoot(reducers),
    StoreDevtoolsModule.instrument({maxAge: 25, logOnly: environment.production}),
    BrowserAnimationsModule,
    MatFormFieldModule,
    ComponentsModule,
    MatDialogModule,
    PipesModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  providers: [
    NotificationFacade,
    LanguageFacade,
    MenuFacade,
    LoaderFacade
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
